import styled from "styled-components";

/**
 * Big "open like an email" modal: a document pane (when the thread has
 * one) sits beside the conversation, mirroring the split the Matter
 * workspace already uses for a document + its AI pane. Without a
 * document the conversation is the whole modal, centered and capped so
 * a one-line message doesn't stretch edge-to-edge.
 */
export const ModalBody = styled.div`
  display: flex;
  height: 100%;
  min-height: 0;
`;

export const DocumentPane = styled.div`
  flex: 1 1 60%;
  min-width: 0;
  height: 100%;
  border-right: 1px solid #dde2e9;
  position: relative;
`;

export const ConversationPane = styled.div`
  flex: 1 1 40%;
  min-width: 320px;
  max-width: 480px;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const ConversationOnlyPane = styled.div`
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  max-width: 640px;
`;

export const ModalTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-right: 32px;
`;

export const ModalTitleText = styled.div`
  min-width: 0;
`;

export const ModalSubject = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #1b2028;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ModalMeta = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #5a6c87;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const OpenInMatterButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  height: 28px;
  padding: 0 12px;
  border-radius: 18px;
  border: 1px solid #dde2e9;
  background: #fff;
  color: #5a6c87;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;

  &:hover {
    border-color: #c8d0db;
    background: #f2f5f9;
    color: #0c53bb;
  }
`;
